import React, { useEffect, useState } from "react";
import { getCurrencyOptions, setDefaultCurrency } from "adminApi/CurrencyListApi/CurrencyList";
import { showError, showSuccess } from "utils/notifications";
import FormSelect from "Common/Custom/FormSelect";

/**
 * DefaultCurrencyForm Component
 * Provides a quick way to select and set the global default currency.
 */
const DefaultCurrencyForm = ({ onUpdate, refresh }) => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCurrencies = async () => {
    try {
      const res = await getCurrencyOptions();
      if (res?.success) {
        const data = res.data || [];
        setCurrencies(data);
        const defaultCurr = data.find(c => c.is_default === 1);
        if (defaultCurr) setSelectedId(defaultCurr.currencyid);
      }
    } catch (err) {
      console.error("Error fetching currencies for dropdown:", err);
    }
  };

  useEffect(() => {
    fetchCurrencies();
  }, [refresh]);

  const handleSelectChange = (valOrEvent) => {
    if (valOrEvent && valOrEvent.target) {
      setSelectedId(valOrEvent.target.value);
    } else if (valOrEvent && typeof valOrEvent === "object") {
      setSelectedId(valOrEvent.value);
    } else {
      setSelectedId(valOrEvent);
    }
  };

  const handleSetDefault = async () => {
    if (!selectedId) {
      showError("Please select a currency");
      return;
    }
    setLoading(true);
    try {
      const res = await setDefaultCurrency(selectedId);
      if (res?.success) {
        showSuccess("Default currency updated successfully");
        if (onUpdate) onUpdate();
      } else {
        showError(res?.error || "Failed to update default currency");
      }
    } catch (err) {
      console.error("Error setting default currency:", err);
      showError("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row g-3 align-items-end mb-4">
      <div className="col-md-4">
        <FormSelect
          field={{
            name: "default_currency",
            label: "Select Default Currency",
            placeholder: "Select Currency",
            required: true,
          }}
          value={selectedId}
          handleChange={handleSelectChange}
          options={currencies.map((c) => ({ 
            value: c.currencyid, 
            label: `${c.currencyname} (${c.curr_icon})` 
          }))}
        />
      </div>
      <div className="col-md-2">
        <button
          type="button"
          className="btn btn-primary w-100"
          onClick={handleSetDefault}
          disabled={loading || !selectedId}
        >
          {loading ? "Updating..." : "Set Default"}
        </button>
      </div>
    </div>
  );
};

export default DefaultCurrencyForm;
